export const SET_USER_INFO = 'SET_USER_INFO';
export const UPD_USER_INFO = 'updUserInfo';
export const SET_PROVIDER_ITEMS = 'setProviderItems';
export const SET_SHOP_ITEMS = 'setShopItems';
export const SET_ADD_LIST = 'setAddList';
export const SET_ADDRESS_ID = 'setAddressId';
export const SET_RX_SHADE_CONFIG = 'setRxShadeConfig'

